import { makeStyles } from '@material-ui/core';

const sideRightStyles = makeStyles({
    sideRight: {
        height: '100vh',
        width: '65px',
        color: 'white',
        overflowY: 'auto',
        backgroundColor: '#416ce1',
        position: 'sticky',
        top: 0,
        bottom: 0,
        right: 0,
        display: 'flex',
        flexDirection: 'column',
        direction: (props) => (props.rtl ? 'ltr' : 'rtl'),
        justifyContent: 'space-between'
    },

    topLogoContainer: {
        padding: '20px 9px 0 9px'
    },
    hr: {
        height: '1px',
        backgroundColor: '#f0f3fa',
        border: 'none',
        opacity: '0.5'
    },
    column: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        padding: '40px 0px 0 0'
    },
    allPatientButton: {
        width: '100%',
        background: 'transparent',
        border: 'none',
        outline: 'none',
        '&:hover': {
            background: 'rgba(255,255,255,0.2)'
        }
    },
    listOfItemPatient: {
        marginTop: '4px',
        display: (props) => (props.open ? 'flex' : 'none'),
        flexDirection: 'column',
        '& > a': {
            padding: '8px 12px 8px 23px'
        }
    },
    active: {
        background: '#fff',
        color: '#416ce1'
    },
    wrapper: (props) => ({
        padding: props.rtl ? '20px 6px 0 0 ' : '20px 0px 0 6px',

        '& > div': {
            width: '100%',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            position: 'relative',
            zIndex: '1',
            margin: '15px 0'
        },
        '& > div > a': {
            width: '100%',
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center'
        },
        '& > div a': {
            padding: '8px 8px 8px 8px',
            borderTopRightRadius: props.rtl ? '5px' : 'unset',
            borderTopLeftRadius: !props.rtl ? '5px' : 'unset',
            borderBottomRightRadius: props.rtl ? '5px' : 'unset',
            borderBottomLeftRadius: !props.rtl ? '5px' : 'unset',
            height: '40px'
        },
        '& > div a:hover': {
            backgroundColor: 'rgba(255,255,255,0.2)'
        },
        '& > div:last-child > a': {
            marginBottom: '10px'
        }
    }),
    activeIcon: {
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255,255,255,0.2)'
    },
    selectedPatients: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        '& a:hover': {
            backgroundColor: '#fff !important',
            color: '#416ce1'
        }
    },
    selectedPatientsLink: {
        marginBottom: '5px',
        padding: '5px 0',
        display: 'block !important',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        height: '35px !important',
        fontSize: '12px',
        textAlign: 'start',
        unicodeBidi: 'plaintext'
    },
    iconsContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: (props) => (props.rtl ? '0px 8px 40px 0px' : '0px 0 40px 8px')
    },
    lineSeparator: {
        borderTop: '1px solid rgba(255,255,255,0.4)',
        width: '100%',
        height: '1px',
        margin: (props) => (props.rtl ? '0 0 0 8px' : '0 8px 0 0')
    },
    img: (props) => ({
        width: '100%',
        marginTop: '30px',
        display: 'flex',
        justifyContent: 'center',
        '& > *': {
            cursor: 'pointer'
        },
        '& > a': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px 0',
            borderTopRightRadius: props.rtl ? '5px' : 'unset',
            borderTopLeftRadius: !props.rtl ? '5px' : 'unset',
            borderBottomRightRadius: props.rtl ? '5px' : 'unset',
            borderBottomLeftRadius: !props.rtl ? '5px' : 'unset'
        },
        '& > a img': {
            width: '24px',
            height: '24px'
        },
        '& >a:first-child': {
            marginTop: '0px'
        },
        '&:last-child': {
            width: '40px',
            height: '40px',
            position: 'relative'
        }
    }),

    dialogRight: {
        position: 'absolute',
        bottom: 0,
        right: '32px'
    },
    dialogLeft: {
        position: 'absolute',
        bottom: 0,
        left: '32px'
    },
    backdrop: {
        backgroundColor: 'transparent'
    },
    dialogContainer: {
        padding: '16px 17px'
    },
    dialogWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: (props) => (props.rtl ? 'flex-end' : 'flex-start')
    },
    name: {
        fontFamily: 'inherit',
        fontSize: '13px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: '1.69',
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#232733'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: (props) => (props.rtl ? 'row' : 'row-reverse'),
        marginTop: '14px',
        cursor: 'pointer',
        '& span': {
            fontFamily: 'inherit',
            fontSize: '13px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: '1.69',
            letterSpacing: 'normal',
            textAlign: 'right',
            color: '#232733'
        }
    },
    logoutMessage: {
        margin: '0 3px'
    },
    tooltipDetailRow: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: (props) => (props.rtl ? 'row' : 'row-reverse'),
        '& svg': {
            margin: (props) => (props.rtl ? '0 15px 0 0' : '0 0 0 15px'),
            cursor: 'pointer'
        },
        '& > div': {
            margin: '0 2px'
        }
    },
    age: {
        fontFamily: 'mainFont',
        fontSize: '13px',
        margin: '0 2px'
    }
});

export default sideRightStyles;
